import {Component, DestroyRef, inject, Input, OnDestroy, OnInit} from '@angular/core';
import {SelectFormControlItem, SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {BokkzIbDataService, IncomeTaxEntity} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormControl, FormGroup} from '@angular/forms';
import {filter, Observable, shareReplay, take} from 'rxjs';
import {SharedUiTooltipModule} from '@snelstart/ui-tooltip';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {SharedUiButtonModule} from '@snelstart/ui-button';
import {CommonModule} from '@angular/common';
import {SharedUiAlertModule} from '@snelstart/ui-alert';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-relatiegegevens',
  templateUrl: './relatiegegevens.component.html',
  styleUrls: ['./relatiegegevens.component.scss'],
    imports: [
        SharedUiTooltipModule,
        SharedUiDetailsModule,
        SharedUiFormControlsModule,
        SharedUiButtonModule,
        CommonModule,
        SharedUiAlertModule
    ]
})
export class RelatiegegevensComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private dataService = inject(BokkzIbDataService);
  private destroyRef = inject(DestroyRef);

  public optionsJaNee: SelectFormControlItem<boolean | undefined>[] = [
    {value: true, label: 'Ja, heel jaar fiscaal partner'},
  ];

  public optionsJaNeeVoorwaarden: SelectFormControlItem<boolean | undefined>[] = [
    {value: true, label: 'Ja, wel van toepassing'},
    {value: false, label: 'Nee, niet van toepassing'},
  ];

  readonly incomeTaxEntity$: Observable<IncomeTaxEntity> =
    this.dataService.incomeTaxEntity$.pipe(
      filter((data): data is IncomeTaxEntity => !!data?.sstRelationId),
      takeUntilDestroyed(this.destroyRef),
      shareReplay({bufferSize: 1, refCount: true})
    );

  public formGroup = new FormGroup({
    omschrijving: new FormControl<string | null>(null),
    datumOverlijdenPartner: new FormControl<Date | null>(null),
    datumScheiding: new FormControl<Date | null>(null),
    datumTrouwen: new FormControl<Date | null>(null),
    periodeIngeschrevenOpZelfdeAdres: new FormGroup({
      begindatum: new FormControl<Date | null>(null),
      einddatum: new FormControl<Date | null>(null),
    }),
    kiestVoorHeleJaarPartnerschap: new FormControl<boolean | null>(null),
    voldaanAanFiscaalPartnerschapVoorwaarden: new FormControl<boolean | null>(null),
  });

  ngOnInit(): void {
    this.incomeTaxEntity$.pipe(
      take(1),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(entity => {
      this.formGroup.reset({}, { emitEvent: false });
      this.formGroup.patchValue(entity?.aangifte?.aangever.relatiegegevens?.at(0) ?? {}, {emitEvent: false});
    });
  }

  ngOnDestroy(): void {
    this.saveForm();
    this.dataService.calculateLatestIncomeTaxReturn().subscribe();
  }

  saveForm(): void {
    const form = this.formGroup.getRawValue();

    this.dataService.patchIncomeTaxEntity(currentEntity => {
      if (!currentEntity.aangifte) {
        return currentEntity;
      }

      return {
        ...currentEntity,
        aangifte: {
          ...currentEntity.aangifte,
          aangever: {
            ...currentEntity.aangifte.aangever,
            relatiegegevens: [{
              omschrijving: form.omschrijving ?? undefined,
              datumOverlijdenPartner: form.datumOverlijdenPartner ?? undefined,
              datumScheiding: form.datumScheiding ?? undefined,
              datumTrouwen: form.datumTrouwen ?? undefined,
              periodeIngeschrevenOpZelfdeAdres: form.periodeIngeschrevenOpZelfdeAdres ? {
                begindatum: form.periodeIngeschrevenOpZelfdeAdres.begindatum ?? undefined,
                einddatum: form.periodeIngeschrevenOpZelfdeAdres.einddatum ?? undefined,
              } : null,
              kiestVoorHeleJaarPartnerschap: form.kiestVoorHeleJaarPartnerschap ?? undefined,
              voldaanAanFiscaalPartnerschapVoorwaarden: form.voldaanAanFiscaalPartnerschapVoorwaarden ?? undefined,
            }]
          },
        },
      } as IncomeTaxEntity;
    });
  }
}

